'use strict';

var util = require('../util');

var index = util.createSimpleFC({
    name: 'button-line',
    className: 'btn-line'
});

module.exports = index;
